<div class="lum-modal lum-c-created-picklist-per-order-notifications-summary">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      notification?.data?.title
    }}</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="m-5">
      <span class="font-500">Created: </span> {{ notification.data.created || 0 }}
    </div>
    <div class="m-5">
      <span class="font-500">Existing Picklists: </span>
      {{ notification.data.existing || 0 }}
    </div>
    <div class="m-5">
      <span class="font-500">Unfulfillable Orders: </span>
      {{ notification.data.unfulfillable || 0 }}
    </div>
  </div>
</div>
